import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=54987c67&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=54987c67&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54987c67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54987c67')) {
      api.createRecord('54987c67', component.options)
    } else {
      api.reload('54987c67', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=54987c67&scoped=true", function () {
      api.rerender('54987c67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teacher/components/manage.vue"
export default component.exports